import { NgModule } from '@angular/core';
import { SharedUiModule } from 'src/app/shared/shared-ui.module';
import { DashboardCalendarWidgetComponent } from './dashboard-calendar-widget.component';

@NgModule({
  declarations: [DashboardCalendarWidgetComponent],
  imports: [SharedUiModule],
  exports: [DashboardCalendarWidgetComponent],
})
export class DashboardCalendarWidgetModule {}
